export default "__VITE_ASSET__D5USMGdv__"